<header class="app-header" id="navbar-main">
  <div class="app-header__title" [ngStyle]="{ color: style || '#111827' }">{{ nameHeader }}</div>
  <div ngbDropdown placement="bottom-right">
    <button type="button" class="profile-trigger" ngbDropdownToggle [attr.aria-label]="texts.openProfileMenu">
      <span class="profile-avatar" aria-hidden="true">{{ userInitials }}</span>
      <span class="profile-copy"><strong>{{ texts.helloPrefix }} {{ nameProfile || texts.userFallback }}!</strong><small *ngIf="state">{{ state }}</small></span>
      <em class="fas fa-chevron-down profile-chevron" aria-hidden="true"></em>
    </button>
    <div class="dropdown-menu dropdown-menu-right profile-menu" ngbDropdownMenu>
      <button class="dropdown-item" type="button" (click)="profile()"><em class="fas fa-user"></em>{{ texts.myProfile }}</button>
      <button class="dropdown-item" type="button" (click)="password()"><em class="fas fa-key"></em>{{ texts.changePassword }}</button>
      <div class="dropdown-divider"></div>
      <button class="dropdown-item logout" type="button" (click)="closeLogout()"><em class="fas fa-sign-out-alt"></em>{{ texts.closeSession }}</button>
    </div>
  </div>
</header>
